import { render, staticRenderFns } from "./CorpPopup.vue?vue&type=template&id=3884aa04&scoped=true"
import script from "./CorpPopup.vue?vue&type=script&lang=ts"
export * from "./CorpPopup.vue?vue&type=script&lang=ts"
import style0 from "./CorpPopup.vue?vue&type=style&index=0&id=3884aa04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884aa04",
  null
  
)

export default component.exports